import { Component, OnInit } from "@angular/core";
import { Project } from "src/app/model/project.dataContract";
import { SharedService } from "src/app/service/shared.service";

@Component({
  selector: "app-project",
  templateUrl: "./project.component.html",
  styleUrls: ["./project.component.css"],
})
export class ProjectComponent implements OnInit {
  projectList: Array<Project>;
  panelOpenState: boolean;
  constructor(public sharedService: SharedService) {}

  ngOnInit(): void {
    this.projectList = new Array<Project>();
    this.projectList = [
      {
        Name: "SI Management",
        Role: "Planner, Documentation, Development",
        Year: "2020",
        Description: `
        It is an inventory as well as vehicle management and maintenance product which provides the status and statistics of most component of which are used in the vehicle. This product is useful for the organization who has 100's or 1000 of Vehicles and requires daily expenses reports for that.
        `,
        Technology: "",
        Technologies: [
          "Express JS",
          "Vue JS",
          "Vuetify",
          "Flutter",
          "SQL-Server",
          "Azure",
          "Jest",
        ],
      },
      {
        Name: "Vehicle Management",
        Role: "Planner, Documentation, Development, Build/Releases",
        Year: "2018-2020",
        Description: `
        It is an inventory as well as vehicle management and maintenance product which provides the status and statistics of most component of which are used in the vehicle. This product is useful for the organization who has 100's or 1000 of Vehicles and requires daily expenses reports for that.
        `,
        Technology: "",
        Technologies: [
          "C#",
          "HTML5 and CSS",
          "AZURE",
          "Angular",
          "Angular Material",
          ".NET Core",
          "Sql-Server",
          "JavaScript",
          "TypeScript",
          "Wijmo Controls",
          "FlexLayout",
          "EPPlus",
          "SheetJS",
          "FlexLayout",
        ],
      },
      {
        Name: "New Logistics",
        Role: "Documentation, Development, Build/Releases",
        Year: "2017-2020",
        Description: `
        It is web-Application for Logistics industries for their day to day work. It helps clients to plans, implements, and controls the efficient, effective, forward, and reverse flow and storage of goods, services, and related information between the point of origin and the point of consumption in order to meet client's requirement. Many reports are procured to clients which are based on tabular and excels format. with the help of SMS and Email services, Our clients can provide reports with their customers or any intended entities.
        `,
        Technology: "",
        Technologies: [
          "C#",
          "HTML",
          "JQuery",
          "Azure webservice and blob storage",
          "Bootstrap",
          "CSS",
          "JS",
          "Sql-Server",
          "Asp.net",
          "Windows Forms Application",
          "TextLocal",
        ],
      },
      {
        // Name: "Autograder (Freelancing project)",
        Name: "Autograder (Freelancing project)",
        Role: "POC, frontend and backend services development",
        Year: "2018",
        Description: `
        Application based on Automated grading system (rubric),
        it accepts user/student’s Java language program (assignments were given by instructor)
        which complies the code at the server-side and calculate all the
        test cases given by examiner or instructor.
        `,
        Technology: "",
        Technologies: [
          "Java",
          "HTML5",
          "CSS3",
          "MYSQL",
          "Bootstrap",
          "JavaScript",
        ],
      },
      {
        Name: "WForesee (weather forecast application) [Major]",
        Role: "Documentation and Development",
        Year: "2017",
        Description: `
        WForesee is a weather forecasting app, which provides quantitative data
        from REST web services and it's a scientific understanding of atmospheric
        processes to project how the atmosphere will change with the help of sophisticated
        technologies. Also, provide health guide on current weather conditions.
        Also, the user has two location modes which depend on accuracy and battery usage.
        Application user can get all forecast information by the help of GPS and Cellular tower location.
        Moreover, the user can access 5 days/3 hours and 16 days forecast on demand. Special skin
        protection push notification service access given to the only premium users.
        `,
        Technology: "",
        Technologies: [
          "Android Studio",
          "JSON",
          "RESTApi",
          "MYSQL",
          "SQLite",
          "Java",
          "Open Weather API",
        ],
      },
      {
        Name: "RDS (remote desktop services) Documentation [Minor]",
        Role: "POC and SRS Creation",
        Year: "2016",
        Description: `
      Remote desktop services are a potentially huge growth area and several companies are currently
      developing software that enables users to access remote systems from the offices or other remote locations by using even embedded system. By using platform-independent languages like c#. for development, gives freedom to use the same application in a different system.
      `,
        Technology: "",
        Technologies: [],
      },

      {
        Name: "Café Relation (Freelancing project)",
        Role: "",
        Year: "2015",
        Description: `
        Billing application for restaurant orders, where user can take orders from
        customers and save it into a database for future references and Admin can
        their product details and retrieve information from orders logs.
        `,
        Technology: "",
        Technologies: ["Java", "AWT/Swings", "MYSQL"],
      },
    ];
  }
}
